import CopyIcon from "../../../../assets/svg/CopyIcon";

const ContactDetails = () => {
  return (
    <div className="grid grid-cols-3 gap-10">
      <div className="flex flex-col gap-4">
        <span className="font-bold text-sm text-charcoal">Office Address</span>
        <span className="text-xs font-medium text-charcoal">
          12AB Apartment, 1 High Street, Bristol, United Kingdom, 223400
        </span>
      </div>

      <div className="flex flex-col gap-4">
        <span className="font-bold text-sm text-charcoal">Contact Number</span>
        <span className="text-xs font-medium text-charcoal flex items-center gap-5">
          +1 234-777-2399
          <CopyIcon className={'w-4 h-4'} fill="gray"/>
        </span>
      </div>

      <div className="flex flex-col gap-4">
        <span className="font-bold text-sm text-charcoal">Email Address</span>
        <span className="text-xs font-medium text-charcoal flex items-center gap-5">
          sarahcole_123@gmail.com
          <CopyIcon className={'w-4 h-4'} fill="gray"/>
        </span>
      </div>
    </div>
  );
};

export default ContactDetails;
